<template>
  <div v-if="docs">
    <customer-profile-card :id="clientId" :clientDetails="docs.created_by" />
    <v-card class="mb-5">
      <div class="invoice-heading">
        <b class="invoice-title">Invoice</b>
      </div>
      <v-card-title class="justify-space-between text-left borderBottom">
        <div>
          No.{{ get(docs, 'sid') }}

          <br />
          <span> Seat No.{{ get(localTimeTable, 'Seat') }}</span>
          <v-icon
            @click="showTimeTableEditDialog = true"
            :disabled="completedQuotation"
            color="primary"
            class="ml-2"
            >mdi-pencil
          </v-icon>
          <br />
          <span>
            Original Booking Time: {{ computedBookingDate }} {{ computedBookingTimeStart || '-' }} ~
            {{ computedBookingTimeEnd || '-' }}
          </span>
          <div>Customer Service Preference : {{ getServiceType(docs) }}</div>
          <div>Remarks: {{ get(docs, 'remarks') }}</div>
        </div>
        <div>
          <v-dialog v-model="showTimeTableEditDialog" max-width="600px">
            <v-card>
              <v-card-title> Invoice Edit</v-card-title>
              <v-card-text style="padding-bottom: 0; padding-top: 20px">
                <v-text-field
                  v-model="localTimeTable.Seat"
                  placeholder="Set Seat No"
                  label="Seat No"
                  outlined
                />
                <!--                <DatePickerWrapperInputMenu v-model="localTimeTable.Date" />-->
                <!--                <br />-->
                <!--                {{ localTimeTable.TimeStart || '-' }} ~ {{ localTimeTable.TimeEnd || '-' }}-->
                <!--                <v-dialog ref="timeDialog" v-model="timeDialog" width="580px">-->
                <!--                  <template v-slot:activator="{ on }">-->
                <!--                    <v-icon v-on="on">mdi-clock-outline</v-icon>-->
                <!--                  </template>-->
                <!--                  <v-card>-->
                <!--                    <v-card-text class="px-0">-->
                <!--                      <v-row class="mx-0">-->
                <!--                        <v-col :cols="6" class="px-0">-->
                <!--                          <v-time-picker-->
                <!--                            v-if="timeDialog"-->
                <!--                            v-model="localTimeTable.TimeStart"-->
                <!--                            format="24hr"-->
                <!--                          >-->
                <!--                          </v-time-picker>-->
                <!--                        </v-col>-->
                <!--                        <v-col :cols="6" class="px-0">-->
                <!--                          <v-time-picker-->
                <!--                            v-if="timeDialog"-->
                <!--                            v-model="localTimeTable.TimeEnd"-->
                <!--                            format="24hr"-->
                <!--                          >-->
                <!--                          </v-time-picker>-->
                <!--                        </v-col>-->
                <!--                      </v-row>-->
                <!--                    </v-card-text>-->
                <!--                    <v-card-actions>-->
                <!--                      <v-btn @click="timeDialog = false">Done</v-btn>-->
                <!--                    </v-card-actions>-->
                <!--                  </v-card>-->
                <!--                </v-dialog>-->
              </v-card-text>
              <v-card-actions class="d-flex justify-space-between">
                <v-btn @click="actionCancel"> Cancel</v-btn>
                <v-btn @click="promptSaveTimeTable"> Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <div>
          <template v-if="isAdmin">
            <v-btn class="void-btn" v-if="!docs.isVoided" @click="actionVoid(id)" color="error">
              Void
            </v-btn>
          </template>
          <div v-if="docs.isVoided === true">
            <VoidTag :value="docs"></VoidTag>
          </div>
          <v-switch
            :disabled="completedQuotation || !masterHasAuth"
            class="mr-5 align-self-center"
            color="#e6c407"
            inset
            v-model="docs.calledCustomerForBookingConfirmation"
            :label="`Called customer confirm booking`"
            @change="x => markCalledCustomerForBookingConfirmation(x)"
          />

          {{ date || '-' }} {{ computedTimeStart || '-' }} ~ {{ computedTimeEnd || '-' }}
        </div>
      </v-card-title>

      <div class="flex" style="display: flex">
        <div class="ml-5 d-flex align-center">
          <h4 class="mr-1">Selected Service:</h4>
          <v-select
            @change="clearService"
            v-model="serviceType"
            :items="serviceProductServiceTypeOption"
            outlined
            hide-details="auto"
            style="max-width: 180px"
            class="mr-1"
            dense
          >
          </v-select>
          <v-btn @click="patchServiceType" v-if="!completedQuotation">Save</v-btn>
        </div>
        <template v-if="docs.status === `97$cancelled` || docs.status === `98$absent`">
          <v-btn class="ml-5 align-self-center" @click="resume">Resume</v-btn>
        </template>
        <v-spacer />
        <v-switch
          :disabled="completedQuotation || !masterHasAuth"
          class="mr-5 align-self-center"
          color="primary"
          inset
          v-model="docs.late"
          :label="`Late`"
          @change="x => markLate(x)"
        />
        <v-btn-toggle
          :disabled="completedQuotation || !masterHasAuth"
          mandatory
          @change="
            v => {
              oldstatus = docs.status;
              this.docs.status = v;
              if (v === '97$cancelled' || v === '98$absent') {
                cancelBookingDialog = true;
              } else {
                markStatusToggle();
              }
            }
          "
          color="primary"
          class="mt-5 mb-5 mr-5"
          :value="docs.status"
        >
          <!-- <v-btn
            :disabled="completedQuotation"
            :value="item"
            v-for="item in ['0$created', '1$arrived', '97$cancelled', '98$absent']"
            :key="item"
            >{{ item | status }}
          </v-btn> -->
          <v-btn
            :disabled="completedQuotation || !masterHasAuth"
            :value="item"
            v-for="item in ['0$created', '1$arrived', '97$cancelled']"
            :key="item"
            >{{ item | status }}
          </v-btn>
        </v-btn-toggle>
      </div>
      <v-divider />
      <div style="padding: 16px">
        <v-row>
          <v-col cols="9">
            <v-card class="mb-5" elevation="2">
              <v-card-title
                >REDO SERVICE ($100)
                <span class="ml-2" v-if="docs.serviceDetails.isRedo">{{
                  get(docs, 'serviceDetails.redoBooking._timetableTime')
                    ? `${moment(
                        get(docs, 'serviceDetails.redoBooking._timetableTime.start'),
                      ).format('DD/MM/YYYY')}  ${timeRange(
                        get(docs, 'serviceDetails.redoBooking._timetableTime'),
                      )}`
                    : '-'
                }}</span>
              </v-card-title>
              <p class="pl-4 pb-4" v-if="docs.serviceDetails.isRedo">
                {{ get(docs, 'serviceDetails.redoBooking._timetable.master.name') }}
                <span v-if="get(docs, 'serviceDetails.redoBooking._timetable.assistantMaster')">
                  (Assist:
                  {{ get(docs, 'serviceDetails.redoBooking._timetable.assistantMaster.name') }})
                </span>
              </p>
            </v-card>
          </v-col>
          <v-col class="text-center" cols="1">
            <v-switch v-model="docs.serviceDetails.isRedo" :disabled="completedQuotation" />
          </v-col>
          <v-col cols="2">
            <h3 v-if="get(docs, 'serviceDetails.isRedo', false)" class="text-center mt-5">
              + $100
            </h3>
          </v-col>
        </v-row>
        <template>
          <v-row v-if="!docs.serviceDetails.isRedo">
            <v-col cols="9">
              <v-card :disabled="!packageCheckBox" class="mb-5" elevation="2">
                <v-card-title class="justify-space-between borderBottom">
                  <div>Existing Package</div>
                  <div>* Select One</div>
                </v-card-title>
                <button
                  v-for="item in filteredClientPackageList"
                  :key="item._id"
                  :class="{
                    selectedPackageItem: item._id === get(computedPackage, '_id'),
                    disabledPackageItem:
                      moment(get(item, 'expireAt')) < moment(docs.time.start).startOf('d'),
                  }"
                  :disabled="
                    completedQuotation ||
                    moment(get(item, 'expireAt')) < moment(docs.time.start).startOf('d')
                  "
                  class="borderBottom full-width text-left"
                  style="padding: 16px; position: relative"
                  @click="choosePackage(item)"
                >
                  <p class="size">Order ID : {{ get(item, 'sid') }}</p>
                  <p class="size">Package Name : {{ get(item.product, 'description') }}</p>
                  <p class="size">Quota : {{ get(item, 'quotaLeft') }}/{{ get(item, 'quota') }}</p>
                  <p class="size">Price : HKD {{ get(item, 'amountPayable') }}</p>
                  <p class="size expire-date">
                    Expire Date : {{ moment(get(item, 'expireAt')).format('DD/MM/YYYY') }}
                  </p>
                  <p class="size">Remarks : {{ get(item, 'remarks') || '-' }}</p>
                  <div v-if="!oidEquals(item.created_by, docs.created_by)" class="sharedTag">
                    {{ get(item, 'created_by.name') }}
                    &nbsp;&nbsp; Phone:{{
                      get(item, 'created_by.phone') | displayPhone
                    }}
                    &nbsp;&nbsp; sid:{{ get(item, 'created_by.sid') }}
                  </div>
                </button>
              </v-card>
            </v-col>
            <v-col cols="1">
              <v-simple-checkbox
                v-if="!completedQuotation"
                v-model="packageCheckBox"
                v-ripple
                :disabled="completedQuotation"
                class="text-center"
                color="primary"
              />
            </v-col>
            <v-col cols="2">
              <h3
                v-if="
                  get(computedPackage, 'quota', false) && get(computedPackage, 'quotaLeft', 0) > 0
                "
                class="text-center"
              >
                - 1 Ticket
              </h3>
              <h3 v-else class="text-center">- 0 Ticket</h3>
            </v-col>
          </v-row>
          <v-row v-if="!docs.serviceDetails.isRedo">
            <v-col cols="9">
              <v-card :disabled="!packageCheckBox" class="mb-5" elevation="2">
                <v-card-title>Different Hair Length?</v-card-title>
                <div style="padding: 16px">
                  <v-btn
                    v-for="x in filteredServiceProductList"
                    :key="x._id"
                    :class="{
                      selectedDifferentHairLength:
                        get(computedServiceProduct, '_id') === x._id && hairLengthCheckBox,
                      cursorInitial: completedQuotation,
                    }"
                    :color="
                      get(computedPackage, 'product._id') === x._id && hairLengthCheckBox
                        ? 'primary'
                        : ''
                    "
                    :disabled="!hairLengthCheckBox"
                    class="mr-3"
                    outlined
                    @click="
                      completedQuotation ? null : (docs.serviceDetails.serviceProduct = x._id)
                    "
                  >
                    {{ x.description }}
                  </v-btn>
                </div>
              </v-card>
            </v-col>
            <v-col class="text-center" cols="1">
              <v-simple-checkbox
                v-if="!completedQuotation"
                v-model="hairLengthCheckBox"
                v-ripple
                :disabled="!packageCheckBox || completedQuotation"
                color="primary"
                @input="handleHairLengthCheckBox"
              />
            </v-col>
            <v-col
              v-if="get(computedAmount, 'differentHairLength') && computedServiceProduct"
              cols="2"
            >
              <h3
                v-if="hairLengthCheckBox && get(computedAmount, 'creditGain') === 0"
                class="text-center"
              >
                + $
                {{
                  get(computedAmount, 'differentHairLength.fee') *
                  get(computedAmount, 'differentHairLength.multiplier', 1)
                }}
                <br />
                ($ {{ get(computedAmount, 'differentHairLength.fee') }} *
                {{ get(computedAmount, 'differentHairLength.multiplier', 1) * 100 }} %)
              </h3>
              <h3
                v-if="hairLengthCheckBox && get(computedAmount, 'creditGain') > 0"
                class="text-center"
              >
                Gain {{ get(computedAmount, 'creditGain', 0) }} (Credit)<br />
                ($ {{ Math.abs(get(computedAmount, 'differentHairLength.fee', 0)) }} *
                {{ get(computedAmount, 'differentHairLength.multiplier', 1) * 100 }} %)
              </h3>
            </v-col>
          </v-row>
          <v-row v-if="!docs.serviceDetails.isRedo">
            <v-col cols="9">
              <v-card :disabled="!singleTreatmentCheckBox" class="mb-5" elevation="2">
                <v-card-title> Single Treatment Service</v-card-title>
                <div style="padding: 16px">
                  <v-btn
                    :disabled="completedQuotation"
                    v-for="item in filteredServiceProductList"
                    :key="item._id"
                    :class="{
                      selectedPackageItem:
                        item._id === get(computedServiceProduct, '_id') && singleTreatmentCheckBox,
                    }"
                    class="mr-3"
                    outlined
                    @click="completedQuotation ? null : chooseSingleTreatment(item._id)"
                  >
                    {{ item.description }}
                  </v-btn>
                </div>
              </v-card>
            </v-col>
            <v-col class="text-center" cols="1">
              <v-simple-checkbox
                v-if="!completedQuotation"
                v-model="singleTreatmentCheckBox"
                v-ripple
                color="primary"
              />
            </v-col>
            <v-col cols="2">
              <h3
                v-if="
                  get(computedServiceProduct, `listedPrice`, false) &&
                  !computedPackage &&
                  singleTreatmentCheckBox
                "
                class="text-center"
              >
                + $ {{ get(computedAmount, 'singleTreatment.listedPrice', '0') }}
              </h3>
            </v-col>
          </v-row>
          <v-row v-if="singleTreatmentCheckBox && !docs.serviceDetails.isRedo">
            <v-col cols="9">
              <v-card class="mb-5" elevation="2">
                <v-card-title>
                  <div>
                    Other Discount
                    <br />
                    <span style="font-size: 18px">
                      * Discount cannot be used in conjunction with package
                    </span>
                    <v-card-text>
                      <v-select
                        v-model="docs.otherDiscount"
                        :items="otherDiscountList"
                        :readonly="completedQuotation"
                        clearable
                        item-text="name"
                        item-value="value"
                        label="Select a discount"
                        outlined
                        return-object
                        :disabled="completedQuotation"
                      >
                        <template v-slot:selection="{ item, index }">
                          <div>
                            {{ item.name }}<br />
                            {{ item.description }}
                          </div>
                        </template>
                      </v-select>
                    </v-card-text>
                  </div>
                </v-card-title>
              </v-card>
            </v-col>
            <v-col class="text-center" cols="1" />
            <v-col cols="2">
              <h3 v-if="get(docs, 'otherDiscount.percentageDiscount', false)" class="text-center">
                * {{ get(docs, 'otherDiscount.percentageDiscount', 1) }}
              </h3>
            </v-col>
          </v-row>
          <v-row v-if="!docs.serviceDetails.isRedo">
            <v-col cols="9"></v-col>
            <v-col class="text-center" cols="1" />
            <v-col cols="2">
              <h3 class="text-center" style="position: relative; color: #6e757c">
                <span v-if="get(computedAmount, `differentHairLength.fee`) >= 0">
                  $
                  {{
                    get(computedAmount, 'differentHairLength.fee', 0) *
                    get(computedAmount, 'differentHairLength.multiplier', 0)
                  }}
                </span>
                <span v-else-if="get(computedAmount, `singleTreatment`)">
                  {{
                    (get(computedAmount, `singleTreatment.listedPrice`) *
                      get(computedAmount, 'otherDiscount.percentageDiscount', 1))
                      | currency
                  }}
                </span>
                <span v-else>0</span>
                <span style="position: absolute; white-space: nowrap; right: 208px">
                  Sub Total:</span
                >
              </h3>
            </v-col>
          </v-row>
          <div>
            <v-divider style="margin: 40px 0px 60px 0px" v-if="!docs.serviceDetails.isRedo" />
            <v-row>
              <v-col cols="9">
                <v-card class="mb-5" elevation="2">
                  <v-card-title>Requested Therapist</v-card-title>
                  <v-card-text>
                    <autocomplete
                      v-model="docs.serviceDetails.masterSpecified"
                      :path="computedAutoCompleteEndpoint"
                      :params="{ filter: { status: '1$accepted' } }"
                      :readonly="completedQuotation"
                      clearable
                      item-text="name"
                      item-value="_id"
                      label="Requested Therapist"
                      @input="handleMasterSpecified"
                      :disabled="completedQuotation"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col class="text-center" cols="1" />
              <v-col cols="2">
                <div></div>
                <h3
                  v-if="
                    docs.serviceDetails.masterSpecified &&
                    docs._timetable &&
                    oidEquals(docs.serviceDetails.masterSpecified, docs._timetable.master)
                  "
                  class="d-flex flex-column align-center"
                >
                  <v-switch
                    v-model="docs.serviceDetails.needExtraFeeForMasterSpecified"
                    :disabled="completedQuotation"
                  />
                  <span v-if="get(docs, 'serviceDetails.needExtraFeeForMasterSpecified')">
                    + $ {{ get(computedAmount, 'needExtraFeeForMasterSpecified', 20) }}
                  </span>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="9">
                <v-card class="mb-5" elevation="2">
                  <v-card-title>Serving Therapist</v-card-title>
                  <v-card-text v-if="docs._timetable">
                    <p class="size">
                      {{ get(docs, '_timetable.master.name', '-') }} (First Assigned to :
                      {{ get(docs, ['firstAssignedMaster', 'name'], '-') }} )
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col class="text-center" cols="1" />
              <v-col cols="2"></v-col>
            </v-row>
            <v-row>
              <v-col cols="9">
                <v-card class="mb-5" elevation="2">
                  <v-card-title>Assistant Therapist</v-card-title>
                  <v-card-text>
                    <autocomplete
                      v-model="localAssistantMaster"
                      :path="computedAutoCompleteEndpoint"
                      :params="{ filter: { status: '1$accepted' } }"
                      :readonly="cancelledOrAbsent"
                      clearable
                      item-text="name"
                      item-value="_id"
                      label="Assistant Therapist"
                      :disabled="!isAdmin || cancelledOrAbsent"
                    />
                    <p class="size">
                      <!--                      {{ get(docs, '_timetable.assistantMaster.name', '-') }} -->
                      (First Assigned to :
                      {{ get(docs, ['firstAssistantMaster', 'name'], '-') }} )
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="2">
                <template v-if="isAdmin && !cancelledOrAbsent && completedQuotation">
                  <v-btn color="primary" persistent @click="patchAssistantMaster">
                    Update Assistant Therapist
                  </v-btn>
                </template>
              </v-col>
            </v-row>
            <v-row v-if="!docs.serviceDetails.isRedo">
              <v-col cols="9">
                <v-card class="mb-5" elevation="2">
                  <v-card-title>Maskin Care Treatment</v-card-title>
                </v-card>
              </v-col>
              <v-col class="text-center" cols="1">
                <div class="text-center">
                  <v-simple-checkbox
                    v-model="docs.serviceDetails.needHairCut"
                    v-ripple
                    :disabled="completedQuotation"
                    color="primary"
                  />
                </div>
              </v-col>
              <v-col cols="2">
                <h3 v-if="docs.serviceDetails.needHairCut" class="text-center">
                  + $ {{ get(computedAmount, 'needHairCut', 380) }}
                </h3>
              </v-col>
            </v-row>
          </div>
          <!-- @deprecated, latest change is to show remarks on the top, not editable         -->
          <!--          <v-row>-->
          <!--            <v-col cols="9">-->
          <!--              <v-card class="mb-5" elevation="2">-->
          <!--                <v-card-title>-->
          <!--                  <span class="mr-5">Other Booking Remarks? </span>-->
          <!--                </v-card-title>-->
          <!--                <v-card-text>-->
          <!--                  <p v-if="completedQuotation" class="text-pre-wrap">{{ docs.remarks }}</p>-->
          <!--                  <v-textarea v-else v-model="docs.remarks" auto-grow outlined rows="2" />-->
          <!--                </v-card-text>-->
          <!--              </v-card>-->
          <!--            </v-col>-->
          <!--            <v-col class="text-center" cols="1"></v-col>-->
          <!--            <v-col cols="2"></v-col>-->
          <!--          </v-row>-->
          <div>
            <v-row>
              <v-col cols="9"></v-col>
              <v-col class="text-center" cols="1"></v-col>
              <v-col cols="2">
                <h3 class="text-center" style="position: relative; color: #6e757c">
                  {{
                    (get(computedAmount, 'needExtraFeeForMasterSpecified', 0) +
                      get(computedAmount, 'needHairCut', 0) +
                      (get(docs, 'serviceDetails.isRedo', false) ? 100 : 0))
                      | currency
                  }}
                  <span style="position: absolute; white-space: nowrap; right: 208px">
                    Sub Total:
                  </span>
                </h3>
              </v-col>
            </v-row>
          </div>
        </template>
        <v-divider style="margin: 40px 0px 40px 0px" />
        <v-row>
          <v-col cols="9">
            <v-card class="mb-5" elevation="2">
              <v-card-title>
                <span class="mr-5">Product Order </span>
              </v-card-title>
              <v-card-text>
                <template v-for="product in invoicePurchasedProducts">
                  <product-item-row
                    :isEditable="!completedQuotation"
                    :item="product"
                    :productCategories="categories"
                  >
                  </product-item-row>
                  <v-divider class="my-3"></v-divider>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="text-center" cols="1"></v-col>
          <v-col cols="2"></v-col>
        </v-row>
        <div>
          <v-row>
            <v-col cols="9"></v-col>
            <v-col class="text-center" cols="1"></v-col>
            <v-col cols="2">
              <h3 class="text-center" style="position: relative; color: #6e757c">
                <!-- {{ docs.purchasedProductDiscount || 0 }}%Off -->
                <span>{{
                  ((computedProductOrderAmount - computedProductOrderSubtotal) * -1) | currency
                }}</span>
                <span style="position: absolute; white-space: nowrap; right: 208px">
                  Discount:
                </span>
              </h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="9"></v-col>
            <v-col class="text-center" cols="1"></v-col>
            <v-col cols="2">
              <h3 class="text-center" style="position: relative; color: #6e757c">
                {{ computedProductOrderSubtotal | currency }}
                <span style="position: absolute; white-space: nowrap; right: 208px">
                  Sub Total:
                </span>
              </h3>
            </v-col>
          </v-row>
        </div>
        <v-divider style="margin: 40px 0px 40px 0px" />
        <v-row>
          <v-col cols="9"></v-col>
          <v-col cols="1" class="text-center"></v-col>
          <v-col cols="2">
            <div class="text-center mb-10" style="position: relative">
              <h2 style="position: absolute; white-space: nowrap; right: 208px">
                Credit Deduction:
                <br />
              </h2>

              <div class="text-center d-flex justify-center">
                <div style="width: 90px">
                  <h2 v-if="completedQuotation">{{ docs.creditDeduct || '0' }}</h2>
                  <v-text-field
                    v-else
                    hide-details
                    prefix="$"
                    type="number"
                    outlined
                    persistent-hint
                    :error="!validCreditDeduct"
                    dense
                    :value="docs.creditDeduct"
                    @input="
                      x => {
                        this.$set(this.docs, 'creditDeduct', Math.abs(x));
                      }
                    "
                  >
                  </v-text-field>
                  <span style="color: #6e757c">
                    Credit : {{ get(docs, 'created_by.creditBalance', 0) }}
                  </span>
                </div>
              </div>
              <h2 style="position: absolute; white-space: nowrap; right: 208px" class="mt-1">
                Cash Discount (Service):
                <br />
              </h2>
              <div class="text-center d-flex justify-center">
                <div style="width: 90px" class="mt-1">
                  <h2 v-if="completedQuotation">{{ docs.adminDeduct || '0' }}</h2>
                  <v-text-field
                    v-else
                    hide-details
                    prefix="$"
                    type="number"
                    outlined
                    persistent-hint
                    dense
                    :value="docs.adminDeduct"
                    :error="!validAdminDeduct"
                    @input="
                      x => {
                        this.$set(this.docs, 'adminDeduct', Math.abs(x));
                      }
                    "
                  >
                  </v-text-field>
                </div>
              </div>
            </div>
            <h2 class="text-center" style="position: relative">
              {{ get(computedAmount, 'amountPayable', 0) | currency }}
              <span class="total-title-style"> Total: </span>
            </h2>
            <div class="d-flex justify-center flex-column">
              <span v-if="completedQuotation" style="color: #6e757c" class="text-center"
                >Payment Method:</span
              >
              <div class="text-center">
                <span style="color: #6e757c" class="text-center">{{ docs.paymentMethod }}</span>
                <v-btn
                  v-if="completedQuotation && !docs.isVoided && (isAdmin || isCashier)"
                  @click="
                    () => {
                      selectedPaymentMethod = docs.paymentMethod;
                      paymentMethodDialog = true;
                    }
                  "
                  icon
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </div>
              <v-dialog v-model="paymentMethodDialog" width="95%" max-width="600px">
                <v-card min-height="250">
                  <v-card-title
                    >Payment Method <v-spacer />
                    <v-btn icon @click="paymentMethodDialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn></v-card-title
                  >
                  <v-card-text>
                    <PaymentMethodSelection v-model="selectedPaymentMethod" />
                  </v-card-text>
                  <v-card-actions>
                    <v-btn class="ml-auto" color="primary" text @click="paymentMethodDialog = false"
                      >Back</v-btn
                    >
                    <v-btn color="primary" persistent text @click="patchPaymentMethod">Save </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="ma-2 d-flex justify-end align-center">
              <div>Checked by therapist</div>
              <div class="d-flex align-center justify-center" style="width: 40px; height: 40px">
                <v-progress-circular
                  v-if="isSubmittingUpdateCheckedByTherapist"
                  indeterminate
                  color="primary"
                  size="18"
                  width="2"
                />
                <v-simple-checkbox
                  v-else
                  v-model="computedCheckedByTherapist"
                  v-ripple
                  class="text-center"
                  color="primary"
                />
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
      <v-divider />
      <slot name="action">
        <div class="d-flex justify-lg-space-between">
          <div class="pl-5 d-flex flex-column justify-center align-start flex-grow-1">
            <template v-if="!completedQuotation">
              <p v-if="!validCreditDeduct" class="mb-0 text-error">* Not enough Credit</p>
              <p v-if="!validAdminDeduct" class="mb-0 text-error">
                * Cash Discount/ Credit Deduction Excess
              </p>
              <p v-if="!formValid" class="mb-0 text-error">
                * Must select either Treatment , Package
              </p>
              <p v-if="noSaved" class="mb-0 text-error">
                * Press "Compute & Save" before "Complete"
              </p>
              <p v-if="!isArrived" class="mb-0 text-error">
                * Please mark "Arrived" before "Complete"
              </p>
              <p v-if="!validServiceAmount" class="mb-0 text-error">
                * The cash discount and credit deduction should not exceed the amount of the
                service.
              </p>
              <p v-if="!validSeat" class="mb-0 text-error">* Please select seat</p>
            </template>
          </div>
          <div class="flex-grow-1 text-end">
            <v-btn
              :disabled="!completedQuotation"
              class="mt-5 mb-5 mr-5"
              color=""
              @click="printReceipt"
            >
              Print
            </v-btn>
            <v-dialog v-model="completeDialog" width="500">
              <v-card>
                <v-card-title> Do you confirm to complete quotation?</v-card-title>
                <v-card-text>
                  Completed quotation will not be editable! Do you confirm to complete quotation?
                </v-card-text>
                <v-divider />
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="completeDialog = false"> Cancel</v-btn>
                  <v-btn
                    :loading="isSubmittingMarkCompleted"
                    color="primary"
                    text
                    persistent
                    @click="debounceMarkCompleted"
                  >
                    Confirm</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!--          Open payment options dialog-->
            <v-dialog v-model="paymentDialog" width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :disabled="
                    !validSeat ||
                    !validServiceAmount ||
                    completedQuotation ||
                    noSaved ||
                    !validCreditDeduct ||
                    !validAdminDeduct ||
                    !isArrived ||
                    (!docs.serviceDetails.isRedo && !formValid)
                  "
                  class="mt-5 mb-5 mr-5"
                  color="primary"
                >
                  {{ completedQuotation ? 'Completed' : 'Complete' }}
                </v-btn>
              </template>
              <v-card>
                <v-card-title>Payment Method</v-card-title>
                <v-card-text>
                  <PaymentMethodSelection v-model="selectedPaymentMethod" />
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" text @click="paymentDialog = false">Back</v-btn>
                  <!-- <v-btn
                    :disabled="isComputing || !selectedPaymentMethod || !masterHasAuth"
                    color="primary"
                    persistent
                    text
                    @click="openCompleteDialog"
                    >Complete
                  </v-btn> -->
                  <v-btn
                    :disabled="isComputing || !selectedPaymentMethod || !masterHasAuth"
                    color="primary"
                    persistent
                    text
                    @click="showCheckoutDialog = true"
                    >Next
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <ProductOrderCheckoutDialog
              v-model="showCheckoutDialog"
              :data="checkoutPreview"
              @confirm="openCompleteDialog"
            />
            <v-btn
              :disabled="
                !validSeat ||
                !validServiceAmount ||
                !formValid ||
                completedQuotation ||
                !validCreditDeduct ||
                !validAdminDeduct ||
                !masterHasAuth
              "
              class="mt-5 mb-5 mr-5"
              color="primary"
              @click="save"
            >
              Compute & Save
            </v-btn>
          </div>
        </div>
      </slot>
    </v-card>
    <!--        <v-card v-else>-->
    <!--          <v-card-title class="justify-space-between text-left">-->
    <!--            <router-link :to="{ name: 'timetables' }">-->
    <!--              need to assign time table first-->
    <!--              <v-icon small color="#24936e"> mdi-open-in-new</v-icon>-->
    <!--            </router-link>-->
    <!--          </v-card-title>-->
    <!--        </v-card>-->
    <!--    <v-card v-else>-->
    <!--      <v-card-title class="justify-space-between text-left"-->
    <!--        >Booking cancelled, need to re-assign booking in timetable-->
    <!--      </v-card-title>-->
    <!--    </v-card>-->
    <v-dialog v-model="cancelBookingDialog" max-width="600">
      <v-card>
        <v-card-title style="align-items: center">
          Confirm to update the status of this booking?
          <v-spacer />
          <v-btn @click="close" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col class="d-flex justify-space-around">
              <v-btn @click="close">Back</v-btn>
              <v-btn @click="cancel">Update</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <VoidDialog ref="voidDialog"></VoidDialog>
  </div>
</template>

<script>
import api from '@/api';
import {
  completeBooking,
  computePayment,
  markLate,
  markPaid,
  markStatus,
  readBooking,
  markCalledCustomerForBookingConfirmation,
  voidBooking,
  masterReadBooking,
  patchPurchasedProducts,
  patchCheckedByTherapist,
  printBookingReceipt,
} from '@/api/bookings';
import { crudList, crudUpdate } from '@/api/crud';
import Autocomplete from '@/components/Autocomplete/Autocomplete';
import CustomerProfileCard from '@/components/Booking/customerProfileCard';
import DatePickerWrapperInputMenu from '@/components/DatePickerWrapperInputMenu';
import { debounce, get } from 'lodash';
import moment from 'moment';
import { getClientTickets } from '@/api/ticketPackage';
import { getOid, oidEquals } from '@/services/utils';
import { getPaymentPreference, getPaymentPreferenceByMaster } from '@/api/systemConfig';
import {
  paymentOfCreditCardOptions,
  paymentOfOthersOptions,
  serviceProductServiceTypeOption,
} from '@/data/optionsConstants';
import { mapGetters } from 'vuex';
import { RESTFUL, serviceProductServiceType } from '@/data/constants';
import { timeRange } from '@/services/filters';
import { listProductCategories } from '@/api/productCategory';
import ProductItemRow from '@/components/PhysicalProductOrder/ProductItemRow';
import VoidDialog from '@/components/VoidDialog.vue';
import VoidTag from '@/components/VoidTag.vue';
import ApiError from '@/api/ApiError';
import PaymentMethodSelection from '@/components/PaymentMethodSelection.vue';
import ProductOrderCheckoutDialog from '@/components/PhysicalProductOrder/ProductOrderCheckoutDialog.vue';

export default {
  name: 'bookingDetailCard',
  components: {
    CustomerProfileCard,
    Autocomplete,
    ProductItemRow,
    VoidDialog,
    VoidTag,
    PaymentMethodSelection,
    ProductOrderCheckoutDialog,
  },
  emits: ['update', 'cancel'],
  props: {
    id: {
      type: String,
    },
    bookingDetails: { type: Object, default: () => {} },
  },
  data() {
    return {
      moment,
      serviceProductServiceType,
      serviceProductServiceTypeOption,
      priceList: {
        differentHairLengthPrice: 0,
        singleTreatmentPrice: 0,
        otherDiscountPercentage: 0,
        masterSpecified: 0,
        hairCut: 0,
      },
      paymentOfCreditCardOptions,
      paymentOfOthersOptions,
      oldstatus: null,
      cancelBookingDialog: false,
      calendarDialog: false,
      timeDialog: false,
      serviceSubTotal: null,
      hairCutSubTotal: null,
      serviceProductList: [],
      clientId: null,
      completeDialog: null,
      paymentDialog: null,
      differentHairLength: null,
      packageCheckBox: false,
      singleTreatmentCheckBox: false,
      hairLengthCheckBox: false,
      otherDiscountCheckBox: false,
      selectedPackage: null,
      timetable: {},
      paymentList: null,
      selectedCustomerLabelList: [],
      showTimeTableEditDialog: false,
      customerLabelField: null,
      clientPackageList: [],
      otherDiscountList: [],
      docs: null,
      localTimeTable: {
        Seat: null,
        Date: null,
        TimeStart: null,
        TimeEnd: null,
      },
      debounceComputePayment: debounce(this.tryCallComputedPayment, 600),
      debounceUpdatePurchasedProductsAndInvoice: debounce(
        this.updatePurchasedProductsAndInvoice,
        600,
      ),
      debounceMarkCompleted: debounce(this.markCompleted, 300),
      selectedPaymentMethod: 'Cash',
      localAssistantMaster: null,
      noSaved: true,
      lastCompletedBooking: null,
      categories: [],
      booking: {},
      isVoided: Boolean,
      isComputing: false,

      paymentMethodDialog: false,

      isSubmittingMarkCompleted: false,
      isSubmittingUpdateCheckedByTherapist: false,
      isSubmittingPrinting: false,

      showCheckoutDialog: false,
      lockNoSave: false,
    };
  },
  watch: {
    bookingDetails: {
      immediate: true,
      async handler(v, oldV) {
        if (v) {
          this.noSaved = !oldV; // first time open the booking card must save once
          this.lockNoSave = true;
          this.docs = v;
          await this.tryCallComputedPayment();
          await this.reload();
          await this.$nextTick();
          this.lockNoSave = false;
        }
      },
    },
    docs: {
      handler(v) {
        if (!this.lockNoSave) this.noSaved = true;
      },
      deep: true,
    },
    packageCheckBox: {
      handler(v) {
        if (!v) {
          this.singleTreatmentCheckBox = true;
          this.hairLengthCheckBox = false;
          if (!this.docs?.serviceDetails?.packageSpecified) return;
          this.docs.serviceDetails.packageSpecified = null;
        } else {
          this.singleTreatmentCheckBox = false;
        }
      },
    },
    singleTreatmentCheckBox: {
      handler(v) {
        if (!v) {
          this.packageCheckBox = true;
          this.otherDiscountCheckBox = false;
          this.docs.otherDiscount = null;
          if (!this.docs?.serviceDetails?.serviceProduct) return;
          this.docs.serviceDetails.serviceProduct = null;
        } else {
          this.packageCheckBox = false;
        }
      },
    },
    'docs.serviceDetails': {
      deep: true,
      async handler(v) {
        if (v) {
          await this.debounceComputePayment();
        }
      },
    },
    'docs.serviceDetails.needHairCut': {
      deep: true,
      async handler(v) {
        if (v) {
          await this.debounceComputePayment();
        }
      },
    },
    'docs.serviceDetails.isRedo': {
      deep: true,
      async handler(v) {
        if (v) {
          this.docs.serviceDetails.redoBooking = this.lastCompletedBooking;
        } else {
          this.docs.serviceDetails.redoBooking = null;
        }
      },
    },
    'docs.otherDiscount': {
      deep: true,
      async handler(v) {
        await this.debounceComputePayment();
      },
    },
    'docs.creditDeduct': {
      deep: true,
      async handler(v) {
        await this.debounceComputePayment();
      },
    },
    'docs.adminDeduct': {
      deep: true,
      async handler(v) {
        await this.debounceComputePayment();
      },
    },
    'docs.purchasedProducts': {
      deep: true,
      async handler(v) {
        await this.debounceUpdatePurchasedProductsAndInvoice();
      },
    },
  },
  computed: {
    ...mapGetters('auth', ['isMaster', 'isAdmin', 'profileId', 'isCashier']),
    cancelledOrAbsent() {
      return this.docs.status === `98$absent` || this.docs.status === `97$cancelled`;
    },
    completedQuotation() {
      return (
        this.docs.status === `98$absent` ||
        this.docs.status === '99$completed' ||
        this.docs.status === `97$cancelled`
      );
    },
    invoicePurchasedProducts() {
      let purchasedProducts = this.docs.purchasedProducts;
      if (this.completedQuotation) {
        purchasedProducts = this.computedAmount.purchasedProducts;
      }
      return purchasedProducts || [];
    },
    computedProductOrderAmount() {
      return this.invoicePurchasedProducts.reduce((acc, el) => {
        const amount = el.product.discountedPrice
          ? el.product.discountedPrice
          : el.product.listedPrice;
        acc += parseFloat(amount * el.qty);
        return acc;
      }, 0);
    },
    computedProductOrderSubtotal() {
      return (
        this.computedProductOrderAmount * (1 - (this.docs.purchasedProductDiscount || 0) / 100)
      );
    },
    date: {
      set(v) {
        this.timetable.time.start = moment(v);
      },
      get() {
        return this.timetable?.time?.start
          ? moment(this.timetable.time.start).format('DD/MM/YYYY')
          : null;
      },
    },
    computedPackage() {
      const res = this.clientPackageList.find(
        x => x._id === this.docs.serviceDetails.packageSpecified,
      );
      if (!res) return null;
      return res;
    },
    computedServiceProduct() {
      const res = this.serviceProductList.find(
        x => x._id === this.docs.serviceDetails.serviceProduct,
      );
      if (!res) return null;
      return res;
    },
    computedBookingDate() {
      return this.docs?.time?.start ? moment(this.docs.time.start).format('DD/MM/YYYY') : null;
    },
    computedBookingTimeStart() {
      return this.docs?.time?.start ? moment(this.docs.time.start).format('HH:mm') : null;
    },
    computedBookingTimeEnd() {
      return this.docs?.time?.end ? moment(this.docs.time.end).format('HH:mm') : null;
    },
    computedTimeStart() {
      return this.timetable?.time?.start ? moment(this.timetable.time.start).format('HH:mm') : null;
    },
    computedTimeEnd() {
      return this.timetable?.time?.end ? moment(this.timetable.time.end).format('HH:mm') : null;
    },
    computedAmount() {
      if (!this.paymentList) return;
      return this.paymentList;
    },
    computedAutoCompleteEndpoint() {
      return this.isAdmin ? 'v1/admin/masterProfiles' : 'v1/master/masterProfiles';
    },
    formValid() {
      const hasService = !!this.docs.serviceDetails?.serviceProduct;
      const isRedo = !!this.docs.serviceDetails?.isRedo;
      //const hasProducts = !!this.docs.purchasedProducts?.length;
      return hasService || isRedo; //|| hasProducts;
    },
    validCreditDeduct() {
      return (
        get(this.docs, 'creditDeduct', 0) <= get(this.docs, 'created_by.creditBalance', 0) &&
        this.computedAmount?.amountPayable >= 0
      );
    },
    validAdminDeduct() {
      return (
        // get(this.docs, 'adminDeduct', 0) <= get(this.docs, 'amountPayable', 0) &&
        this.computedAmount?.amountPayable >= 0
      );
    },
    validServiceAmount() {
      return (
        +(
          (this.computedAmount?.amountPayable || 0) +
          (this.docs?.creditDeduct || 0) -
          (this.computedProductOrderSubtotal || 0)
        ).toFixed(3) >= 0
      );
    },
    validSeat() {
      return !!this.docs?._timetable?.seat;
    },
    isArrived() {
      return this.docs.status === '1$arrived';
    },
    masterHasAuth() {
      return (
        this.isAdmin ||
        this.isCashier ||
        (this.isMaster && this.profileId === getOid(this.docs?._timetable?.master))
      );
    },
    computedCheckedByTherapist: {
      get() {
        return this.docs.checkedByTherapist;
      },
      async set(v) {
        try {
          this.isSubmittingUpdateCheckedByTherapist = true;
          const checkedByTherapist = (await patchCheckedByTherapist(api, getOid(this.docs), v))
            .checkedByTherapist;
          this.$set(this.docs, 'checkedByTherapist', checkedByTherapist);
          this.$store.dispatch('alert/updateAlertMessage', {
            msg: 'Checked by therapist Updated',
            type: 'success',
            color: 'success',
          });
        } finally {
          this.isSubmittingUpdateCheckedByTherapist = false;
        }
      },
    },
    checkoutPreview() {
      return { ...this.docs, paymentMethod: this.selectedPaymentMethod };
    },
    filteredClientPackageList() {
      return this.clientPackageList.filter(item => item.product.serviceType === this.serviceType);
    },
    filteredServiceProductList() {
      return this.serviceProductList.filter(item => item.serviceType === this.serviceType);
    },
    serviceType: {
      get() {
        return (
          this.computedServiceProduct?.serviceType ||
          this.docs?.serviceDetails?.serviceType ||
          this.docs?.serviceDetails?.clientPreferServiceType ||
          serviceProductServiceType.N
        );
      },
      set(v) {
        if (this.docs?.serviceDetails) this.$set(this.docs.serviceDetails, 'serviceType', v);
      },
    },
  },
  methods: {
    get,
    oidEquals,
    timeRange,
    close() {
      this.$set(this.docs, 'status', this.oldstatus);
      this.cancelBookingDialog = false;
    },
    async cancel() {
      // this.docs.status = '97$cancelled';
      await this.markStatusToggle();
      this.cancelBookingDialog = false;
    },
    async resume() {
      try {
        this.docs = await crudUpdate(api, 'v1/admin/bookings', getOid(this.docs), {
          status: '0$created',
        });
        this.$emit('update', this.docs?._timetable?._id);
      } catch (e) {}
    },

    async reload() {
      if (!this.id || !this.bookingDetails) {
        const res = this.isAdmin
          ? await getPaymentPreference(api)
          : await getPaymentPreferenceByMaster(api);
        this.otherDiscountList = res?.otherDiscount || [];
        return;
      }

      if (this.docs._timetable) this.localAssistantMaster = this.docs._timetable.assistantMaster;
      if (!this.docs.creditDeduct) this.docs.creditDeduct = 0;
      this.clientId = getOid(this.docs.created_by);
      const serviceDetails = this.docs.serviceDetails;
      this.timetable = this.docs._timetable;

      const result = await Promise.all([
        crudList(api, RESTFUL.booking.list, {
          filter: {
            status: '99$completed',
            created_by: this.clientId,
            '_timetableTime.end': { $lt: moment(this.docs._timetableTime?.start) },
          },
          populate: [
            'firstAssignedMaster',
            'firstAssistantMaster',
            'created_by',
            { path: '_timetable', populate: ['master', 'assistantMaster'] },
          ],
          sort: {
            '_timetableTime.end': -1,
          },
        }),
        // Get this.docs.serviceDetails?.packageSpecified even it is 0 quotaLeft
        getClientTickets(api, this.clientId, {
          populate: ['sharedWith', 'product', 'created_by'],
          filter: this.docs.serviceDetails?.packageSpecified
            ? {
                $and: [
                  {
                    $or: [
                      { quotaLeft: { $gt: 0 } },
                      { _id: this.docs.serviceDetails?.packageSpecified },
                    ],
                  },
                ],
              }
            : { quotaLeft: { $gt: 0 } },
          limit: -1,
        }),
        crudList(api, 'v1/admin/serviceProducts', { limit: -1 }),
        listProductCategories(api),
        this.isAdmin ? await getPaymentPreference(api) : await getPaymentPreferenceByMaster(api),
      ]);
      const data = await Promise.all(result);
      this.lastCompletedBooking = data[0]?.docs?.[0] || null;
      this.clientPackageList = data[1]?.docs;
      this.serviceProductList = data[2]?.docs;
      this.categories = data[3];
      this.otherDiscountList = data[4]?.otherDiscount || [];

      this.setLocalTimeTable(this.timetable);
      this.hairLengthCheckBox = !!(
        serviceDetails.packageSpecified &&
        get(this.computedAmount, 'differentHairLength.serviceProduct')
      );

      this.singleTreatmentCheckBox = !(this.packageCheckBox = !!serviceDetails.packageSpecified);
    },

    async actionVoid(id) {
      const confirmationResult = await this.$refs.voidDialog.open();
      if (!confirmationResult) return;
      const { voidedPaymentMethod, voidedRemarks } = confirmationResult;

      try {
        const model = await voidBooking(api, id, { voidedPaymentMethod, voidedRemarks });
        this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Voided',
          type: 'success',
          color: 'success',
        });
        this.$emit('void', model);
      } catch (e) {
        const ae = ApiError.wrap(e);
        this.$store.dispatch('alert/updateAlertMessage', {
          msg: ae.message,
        });
      }
      this.$emit('reload');
    },

    handleMasterSpecified() {
      if (this.docs._timetable) {
        this.docs.serviceDetails.needExtraFeeForMasterSpecified = oidEquals(
          get(this.docs, 'serviceDetails.masterSpecified'),
          get(this.docs, '_timetable.master'),
        );
      }
    },
    setLocalTimeTable(timeTable) {
      let temp = {
        Seat: null,
        Date: null,
        TimeStart: null,
        TimeEnd: null,
      };
      if (timeTable && timeTable.time) {
        const { start, end } = timeTable.time;
        if (start) {
          temp.Date = moment(start).format('YYYY-MM-DD');
          temp.TimeStart = moment(start).format('HH:mm');
        }
        if (end) {
          temp.TimeEnd = moment(end).format('HH:mm');
        }
        temp.Seat = timeTable.seat;
      }
      this.localTimeTable = temp;
    },
    async promptSaveTimeTable() {
      // if (!confirm('do you confirm to update quotation?')) return;
      // convert localTimeTable
      const { Seat, Date, TimeStart, TimeEnd } = this.localTimeTable;
      let payload = {
        time: {
          start: moment(Date + ' ' + TimeStart, 'YYYY-MM-DD HH:mm'),
          end: moment(Date + ' ' + TimeEnd, 'YYYY-MM-DD HH:mm'),
        },
        seat: Seat,
      };
      try {
        const result = await crudUpdate(
          api,
          'v1/admin/timetables',
          this.docs?._timetable?._id,
          payload,
        );
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Update Success',
          type: 'success',
          color: 'success',
        });
        //this.$emit('reload');
        if (this.docs?._timetable) this.docs._timetable.seat = result.seat;

        this.$emit('update', this.docs?._timetable?._id);
        this.showTimeTableEditDialog = false;
        this.timeDialog = false;
      } catch (e) {}
    },
    actionCancel() {
      this.showTimeTableEditDialog = false;
      this.setLocalTimeTable(this.timetable);
    },
    async markLate(late) {
      await markLate(api, this.id, late);
      this.$emit('update', this.docs?._timetable?._id);
      await this.$store.dispatch('alert/updateAlertMessage', {
        msg: late ? 'Mark Late' : 'Mark Not Late',
        type: 'success',
        color: 'success',
      });
    },

    async markCalledCustomerForBookingConfirmation(calledCustomerForBookingConfirmation) {
      await markCalledCustomerForBookingConfirmation(
        api,
        this.id,
        calledCustomerForBookingConfirmation,
      );
      this.$emit('update', this.docs?._timetable?._id);
      await this.$store.dispatch('alert/updateAlertMessage', {
        msg: calledCustomerForBookingConfirmation
          ? 'Called customer confirm booking'
          : 'Have Not Called customer confirm booking',
        type: 'success',
        color: 'success',
      });
    },

    openCompleteDialog() {
      this.paymentDialog = false;
      this.showCheckoutDialog = false;
      this.completeDialog = true;
    },
    async markStatusToggle() {
      await markStatus(api, this.id, this.docs.status);
      this.$emit('update', this.docs?._timetable?._id);

      await this.$store.dispatch('alert/updateAlertMessage', {
        msg: 'Mark ' + this.$options.filters['status'](this.docs.status),
        type: 'success',
        color: 'success',
      });
    },
    async patchTimeTableAssistantMaster() {
      await crudUpdate(api, 'v1/admin/timetables', getOid(this.docs._timetable), {
        assistantMaster: this.localAssistantMaster,
      });
    },
    async patchAssistantMaster() {
      try {
        await this.patchTimeTableAssistantMaster();
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Update Assistant Therapist Success',
          type: 'success',
          color: 'success',
        });
      } catch (e) {}
    },
    async markCompleted() {
      try {
        this.isSubmittingMarkCompleted = true;
        await completeBooking(api, this.id, {
          serviceDetails: this.docs?.serviceDetails,
          remarks: this.docs?.remarks,
          otherDiscount: this.docs?.otherDiscount,
          creditDeduct: this.docs?.creditDeduct,
          adminDeduct: this.docs?.adminDeduct,
          ...this.paymentList,
          paymentMethod: this.selectedPaymentMethod,
          assistantMaster: this.localAssistantMaster,
        });
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Mark Completed',
          type: 'success',
          color: 'success',
        });
        this.$emit('reload');
        this.$emit('update', this.docs?._timetable?._id);
        //this.$set(this.docs, 'status', `99$completed`);
        this.completeDialog = false;
        this.$emit('close');
      } catch (e) {
        if (e.code === 'insufficient_balance') {
          alert('Insufficient credit balance');
        } else if (
          e.subcode === 'invalid_status_time_in_future' ||
          (e.code === 'invalid_status' && e.message?.includes('invalid_status_time_in_future'))
        ) {
          alert('Start time not yet meet');
        } else {
          alert('Booking Status must be arrived');
        }
        this.completeDialog = false;
      } finally {
        this.isSubmittingMarkCompleted = false;
      }
    },
    async tryCallComputedPayment() {
      try {
        this.isComputing = true;
        if (this.completedQuotation) {
          this.paymentList = this.docs.computedPayment || (await computePayment(api, this.docs));
        } else {
          this.paymentList = await computePayment(api, this.docs);
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.isComputing = false;
      }
    },
    handleHairLengthCheckBox() {
      if (!this.hairLengthCheckBox) {
        this.docs.serviceDetails.serviceProduct = this.computedPackage?.product?._id;
      }
    },
    choosePackage(item) {
      if (oidEquals(item, this.computedPackage)) {
        this.$set(this.docs.serviceDetails, 'packageSpecified', null);
        this.$set(this.docs.serviceDetails, 'serviceProduct', null);
      } else {
        this.$set(this.docs.serviceDetails, 'packageSpecified', item?._id);
        this.$set(this.docs.serviceDetails, 'serviceProduct', item?.product?._id);
      }

      this.packageCheckBox = true;
    },
    chooseSingleTreatment(id) {
      if (get(this.docs, 'serviceDetails.packageSpecified')) {
        delete this.docs.serviceDetails.packageSpecified;
      }
      this.$set(this.docs.serviceDetails, 'serviceProduct', id);
      this.priceList.singleTreatmentPrice = this.computedServiceProduct?.listedPrice;
    },
    async updatePurchasedProductsAndInvoice() {
      try {
        this.isComputing = true;
        await patchPurchasedProducts(
          api,
          getOid(this.docs),
          this.docs.purchasedProducts,
          this.docs.purchasedProductDiscount || 0,
        );
        await this.debounceComputePayment();
      } catch (error) {
        this.isComputing = false;
      }
    },
    async save() {
      try {
        await crudUpdate(api, 'v1/admin/bookings', this.id, {
          serviceDetails: this.docs?.serviceDetails,
          remarks: this.docs?.remarks,
          amountPayable: this.computedAmount?.amountPayable,
          assistantMaster: this.docs?.assistantMaster,
          otherDiscount: this.docs?.otherDiscount,
          creditDeduct: this.docs?.creditDeduct,
          adminDeduct: this.docs?.adminDeduct,
          computedPayment: this.paymentList,
        });
        await this.patchTimeTableAssistantMaster();
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Saved',
          type: 'success',
          color: 'success',
        });
        this.$emit('update', this.docs?._timetable?._id);
        // this.$emit('close');   //[CHECK] disabled auto close for the convenience of 'marked completed' flow
        this.$emit('reload');
      } catch (e) {
        const ae = ApiError.wrap(e);
        this.$store.dispatch('alert/updateAlertMessage', {
          msg: ae.message,
        });
        if (e?.code === 'forbidden') {
          this.$emit('reload');
        }
      }
    },
    async patchServiceType() {
      try {
        await crudUpdate(api, 'v1/admin/bookings', this.id, {
          'serviceDetails.serviceType': this.serviceType,
        });
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Saved',
          type: 'success',
          color: 'success',
        });
        this.$emit('update', this.docs?._timetable?._id);
      } catch (e) {
        const ae = ApiError.wrap(e);
        this.$store.dispatch('alert/updateAlertMessage', {
          msg: ae.message,
        });
      }
    },
    async patchPaymentMethod() {
      try {
        await crudUpdate(api, 'v1/admin/bookings', this.id, {
          paymentMethod: this.selectedPaymentMethod,
        });
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Saved',
          type: 'success',
          color: 'success',
        });
        this.paymentMethodDialog = false;
        this.docs.paymentMethod = this.selectedPaymentMethod;
        this.$emit('update', this.docs?._timetable?._id);
      } catch (e) {
        const ae = ApiError.wrap(e);
        this.$store.dispatch('alert/updateAlertMessage', {
          msg: ae.message,
        });
      }
    },
    async printReceipt() {
      try {
        this.isSubmittingPrinting = true;
        await printBookingReceipt(api, getOid(this.docs));
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Sent to Printer',
          type: 'success',
          color: 'success',
        });
      } finally {
        this.isSubmittingPrinting = false;
      }
    },
    async clearService() {
      // this.singleTreatmentCheckBox = false;
      // await this.$nextTick();
      // this.packageCheckBox = false;
      this.hairLengthCheckBox = false;
      this.docs.otherDiscount = null;
      if (this.docs?.serviceDetails?.packageSpecified) {
        this.docs.serviceDetails.packageSpecified = null;
      }
      if (this.docs?.serviceDetails?.serviceProduct) {
        this.docs.serviceDetails.serviceProduct = null;
      }
    },
    getServiceType(docs) {
      const clientPreferServiceType = docs?.serviceDetails?.clientPreferServiceType;
      if (!clientPreferServiceType) return '-';
      const tagMapping = {
        [serviceProductServiceType.N]: 'Hair Color (N)',
        [serviceProductServiceType.HG]: 'Hair Growth (HG)',
        [serviceProductServiceType.HL]: 'Highlight (HL)',
        [serviceProductServiceType.Other]: 'Other (O)',
      };
      return tagMapping[clientPreferServiceType] || clientPreferServiceType;
    },
  },
};
</script>

<style scoped lang="scss">
.invoice-heading {
  text-align: center;
  margin-top: 10px;
}

.invoice-title {
  padding-top: 8px;
  font-size: 22px;
  color: var(--v-primary-base);
}

::v-deep {
  .v-input--is-disabled.v-select > .v-input__control > .v-input__slot {
    cursor: default !important;
  }
}

.paymentBox {
  background-color: #f48a03;
  height: 35px;
  width: 100px;
}

.size {
  font-size: 18px;
}

.cursorPointer {
  cursor: pointer;
}

.cursorInitial {
  cursor: initial;
}

.sharedTag {
  right: 0px;
  bottom: 0px;
  position: absolute;
  border-left: 1px solid #b9b9b9;
  border-top: 1px solid #b9b9b9;
  padding: 5px;
}

.selectedPackageItem {
  background-color: var(--v-primary-base) !important;
  color: white;
}

.disabledPackageItem {
  color: #919191;
  .expire-date {
    font-weight: 700;
  }
}

.selectedDifferentHairLength {
  background-color: var(--v-primary-base) !important;
  color: white !important;
}

.chipOrange {
  color: #debc95;
}

.borderBottom {
  border-bottom: 1px solid #b9b9b9;
}

.mt-5.mb-5 {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}
.total-title-style {
  position: absolute;
  white-space: nowrap;
  right: 208px;
  color: var(--v-primary-base);
}
</style>
